//#region IMPORT
import { Button } from '../../../Components/MUIs';
import { Box, Stack, Typography } from '@mui/material';
import DocumentViewer from '../../../Components/Ui/DocumentViewer';
//#endregion

function M_TBG_BASIC_04(props) {
  const ext = props.getExtensionFromUrl(props.pdfFile);

  const renderViewer = () => {
    if (!props.pdfFile) {
      return (
        <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
          작업계획서가 없습니다.
        </Typography>
      );
    }

    switch (ext) {
      case 'pdf':
      case 'hwp':
        return (
          <DocumentViewer
            renderPreview={props.renderPreview}
            loading={props.loading}
            onDocumentLoadSuccess={props.onDocumentLoadSuccess}
            pageNumber={props.pageNumber}
            pageWidth={props.pageWidth}
            pageViewHeight={props.pageViewHeight}
            setPageViewHeight={props.setPageViewHeight}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        );

      default:
        return (
          <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
            미리보기를 지원하지 않는 파일 형식입니다.
          </Typography>
        );
    }
  };

  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          작업계획서
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          파일 자료를 통해 작업계획서를 확인해주세요.
        </Typography>
      </Stack>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
          overflow: 'hidden', // 스크롤 방지
        }}
      >
        {renderViewer()}

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ p: 2, width: '100%' }}
        >
          <Button
            sx={{ width: '100%', height: '36px', borderRadius: '18px' }}
            name="이전"
            onClick={props.goToPrevPage}
          />
          <Typography
            sx={{
              fontWeight: 'bold',
              mx: 6,
              whiteSpace: 'nowrap',
            }}
          >
            {props.pdfFile ? `${props.pageNumber} / ${props.numPages}` : null}
          </Typography>
          <Button
            sx={{ width: '100%', height: '36px', borderRadius: '18px' }}
            name={
              props.pageNumber === props.numPages || !props.pdfFile
                ? '완료'
                : '다음'
            }
            onClick={() => {
              if (props.pageNumber === props.numPages || !props.pdfFile) {
                // props.ActiveButton({
                //   type: 'check2',
                //   id: props.userInfo.userid,
                //   content: true,
                // });
                props.setActiveStep(props.activeStep + 1);
              } else {
                props.goToNextPage();
              }
            }}
          />
        </Stack>
      </Box>
    </>
  );
}

export default M_TBG_BASIC_04;
